// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7f47a418","977":"28449e5e"}[chunkId] + ".chunk.js";
};